<div style="text-align: center;">
    <full-calendar [options]="calendarOptions" class="p-2 pt-4 full-calendar" style="width: 90%; display: block;margin: 0 auto;" #calendar></full-calendar>
</div>
